// extracted by mini-css-extract-plugin
export default {"root":"styles_root__GW2Ed","root-crescendo":"styles_root-crescendo__db4ZW"};